import { request } from '../apis';
import { AttendanceDayStatus } from '../AttendanceTrackingService';

export interface EmployeeVehicle {
  id: string;
  vehicleNumber: string;
  createdAt: string;
}

export interface VehicleSearchRow {
  vehicleId: string;
  vehicleNumber: string;
  date: string | null;
  dayLabel: string | null;
  employeeInfoId: string;
  epfNumber: string;
  employeeName: string;
  arrival?: string | null;
  departure?: string | null;
  hoursWorked?: string | null;
  status: AttendanceDayStatus | null;
}

export interface VehicleSearchResponse {
  from: string | null;
  to: string | null;
  dateRangeLabel: string | null;
  vehicleCount: number;
  items: VehicleSearchRow[];
}

export const VehicleService = {
  getMyVehicles: () => request.get<EmployeeVehicle[]>('vehicles/me'),

  addMyVehicle: (vehicleNumber: string) =>
    request.post<EmployeeVehicle>('vehicles/me', { vehicleNumber }),

  deleteMyVehicle: (vehicleId: string) =>
    request.delete(`vehicles/me/${encodeURIComponent(vehicleId)}`),

  getEmployeeVehicles: (employeeInfoId: string) =>
    request.get<EmployeeVehicle[]>(
      `vehicles/employees/${encodeURIComponent(employeeInfoId)}`
    ),

  addEmployeeVehicle: (employeeInfoId: string, vehicleNumber: string) =>
    request.post<EmployeeVehicle>(
      `vehicles/employees/${encodeURIComponent(employeeInfoId)}`,
      { vehicleNumber }
    ),

  deleteEmployeeVehicle: (employeeInfoId: string, vehicleId: string) =>
    request.delete(
      `vehicles/employees/${encodeURIComponent(
        employeeInfoId
      )}/${encodeURIComponent(vehicleId)}`
    ),

  search: (search: string, from?: string, to?: string) =>
    request.get<VehicleSearchResponse>('vehicles/search', {
      params: { search: search.trim() || undefined, from, to }
    })
};
